const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.account.token,
  avatar: state => state.account.user.avatar,
  name: state => state.account.name,
  introduction: state => state.account.introduction,
  roles: state => state.account.roles,
  permissions: state => state.account.permissions,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  user: state => state.account.user
}
export default getters
